import {FAILURE, PENDING, SUCCESS} from '../../constants'
import eventsJson from '../../../fixtures//reservation_calender_objects_api.json'
import {getReservationCalenderObjects as getReservationCalenderObjectsAPI} from '../../../services/groups'
import {ActionTypes} from './reducer'

export function resetResources(dispatch) {
  dispatch({type: ActionTypes.RESET})
}

export async function removeEventViaID(dispatch, id) {
  try {
    dispatch({
      type: ActionTypes.REMOVE_EVENT_VIA_ID,
      payload: {id: id},
    })
  } catch (e) {
    console.log(`Remove Item Failed`)
    return Promise.reject(e)
  }
}

export async function getReservationEvents(dispatch, group_id, view_data, params = {}) {
  try {
    dispatch({type: PENDING})
    let events = await getReservationCalenderObjectsAPI(group_id, params)
    if (events) {
      events['view_data'] = view_data
    }
    dispatch({type: SUCCESS, payload: {...events}})
    return events // Returning response
  } catch (e) {
    console.log(`Get Reservation Events Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
